import React, { useEffect, useState } from 'react';
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import { Form, Col, Row, Toast } from 'react-bootstrap';
import './Book.css';
import ifoIcon from '../../../../Assets/info.svg';
import Checkout from './Checkout';
import { SET_SELECTED_SERVICE, useAppContext } from '../../../../context';

const Book = () => {
    const { state: { selectedService }, dispatch } = useAppContext();
    const [services, setServices] = useState([]);
    const [show, setShow] = useState(true);

    useEffect(() => {
        const data = [
            {
                _id: 1,
                name: "Custom CRM Development",
                price: "15000",
                description: "Customized CRM solutions for customers, vendors, orders and business management."
            },
            {
                _id: 2,
                name: "Website Development",
                price: "10000",
                description: "Modern responsive websites for startups, businesses and service providers."
            },
            {
                _id: 3,
                name: "Software Development",
                price: "25000",
                description: "Custom software solutions according to business workflow and requirements."
            }
        ];

        setServices(data);

        if (!selectedService.name) {
            dispatch({ type: SET_SELECTED_SERVICE, payload: data[0] });
        }
    }, [selectedService.name, dispatch]);

    useEffect(() => {
        const timer = setTimeout(() => {
            setShow(false);
        }, 7000);

        return () => clearTimeout(timer);
    }, []);

    const handleSelection = e => {
        const getService = services.find(({ name }) => e.target.value === name);
        dispatch({ type: SET_SELECTED_SERVICE, payload: getService });
    };

    const stripePromise = loadStripe('pk_test_51Ii2KaCKKXM4eFaOJWCOr8pS4GVkoCerGCRHefo7hDpLYMcjpGqPNpoeydvFApWXDSSMnfXNzdtwRcF1o8XmTk3H00xDH8wKZc');

    return (
        <div className="bookForm">
            <Toast show={show} onClose={() => setShow(false)} className="bookToast">
                <Toast.Header>
                    <img src={ifoIcon} className="rounded mr-2 toastIcon" alt="" />
                    <strong className="mr-auto">Info</strong>
                    <small>02 seconds ago</small>
                </Toast.Header>
                <Toast.Body>
                    4242 4242 4242 4242 you can use this card number for testing
                </Toast.Body>
            </Toast>

            <Row>
                <Col md={6} xs={12} className="my-3">
                    <Form.Label style={{ fontWeight: "bold" }}>Service</Form.Label>
                    <select className="form-select" onChange={handleSelection} value={selectedService.name || ""}>
                        {
                            services.map(({ _id, name }) => (
                                <option key={_id} value={name}>{name}</option>
                            ))
                        }
                    </select>
                </Col>

                <Col md={6} xs={12} className="my-3">
                    <Form.Label style={{ fontWeight: "bold" }}>Price</Form.Label>
                    <div className="priceInput">
                        ₹{selectedService.price}
                    </div>
                </Col>
            </Row>

            <Elements stripe={stripePromise}>
                <Checkout />
            </Elements>
        </div>
    );
};

export default Book;